import { Pipeline, PipelineOperation, SqlOperation } from '../../types';

const isSqlOperation = (op: PipelineOperation): op is SqlOperation => op.operation === 'sql';

export const getSqlOperation = (pipeline: Pipeline): SqlOperation | undefined =>
  pipeline.operations.find(isSqlOperation);
